import { MESSAGES } from 'src/modules/common/constants';
import { memo, PropsWithChildren } from 'react';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { LocalesEnum } from 'src/generated/operations.ts';
import { Price } from 'src/common/Price/Price';

type Props = PropsWithChildren<{
    isMobile?: boolean;
    price: number | null;
    currency: string;
    locale: LocalesEnum;
}>

export const SubTotal = memo(({ isMobile, price, currency, locale, children }: Props) => (
    <div className="vss-subtotal">
        {isMobile && children}

        <div className="vss-subtotal__content-wrapper">
            <p className="vss-subtotal__text">
                <I18n messageId={MESSAGES.checkoutSubTotal}/>
            </p>

            <div className="vss-subtotal__content">
                <div className="vss-subtotal__actions">
                    {!isMobile && children}
                </div>

                {price === null ? '\u2014' : (<Price currency={currency} price={price} locale={locale}/>)}
            </div>
        </div>
    </div>
));
